export default "__VITE_ASSET__pC1Voe6F__";